import React, { useState, useEffect } from 'react';

import ImageCarouselLoader from './ImageCarouselLoader';

export default function InitialRecipeLoader() {
  const [quote, setQuote] = useState('');

  useEffect(() => {
    fetch('/quotes.json')
      .then((res) => res.json())
      .then((quotes) => {
        const randomQuote = quotes[Math.floor(Math.random() * quotes.length)];
        setQuote(randomQuote);
      })
      .catch((error) => {
        console.error('Error loading quotes:', error);
      });
  }, []);

  return (
    <div className="loader-container" style={{ position: 'relative', minHeight: '400px' }}>
      {quote && (
        <div
          style={{
            position: 'absolute',
            top: '35%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center',
            padding: '30px',
            maxWidth: '600px',
            zIndex: 10,
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          }}
        >
          <p
            style={{
              fontSize: '18px',
              fontStyle: 'italic',
              color: '#333',
              lineHeight: '1.6',
              margin: 0,
            }}
          >
            {quote}
          </p>
        </div>
      )}
      <div className="skeleton" style={{ height: '32px', width: '70%' }}></div> {/* Title Placeholder */}
      <ImageCarouselLoader />
      <div className="skeleton" style={{ height: '18px', width: '90%' }}></div> {/* Summary Placeholder */}
      <div className="skeleton" style={{ height: '18px', width: '80%' }}></div> {/* Additional text line */}
      <div className="skeleton" style={{ height: '300px', width: '100%' }}></div> {/* Large box for instructions */}
    </div>
  );
}